var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { SelectFilter, DropDown } from "sb-resp-ui";
import { ui } from "../../../contracts";
import { getDropDownOptions, getChunkSizeToRender } from "../../../helpers";
import { RenderBets } from "../components";
let BettingHistory = class BettingHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.dataProvider;
    }
    renderError() {
        return (React.createElement("div", { className: "rj-betting-history__message rj-betting-history__message--error", "data-uat": "betting-history-message-error" }, this.state.dict.ErrorMessage));
    }
    renderLoadMore() {
        return (this.state.shouldShowLoadMore
            ? React.createElement(ui.LoadMoreBtn, { onClick: this.state.loadMore, phrase: this.state.dict.LoadMore })
            : "");
    }
    renderBets() {
        return this.state.isEmpty
            ? React.createElement("div", { className: "rj-betting-history__message rj-betting-history__message--no-data", "data-uat": "betting-history-message-no-data" }, this.state.dict.NoData)
            : React.createElement(RenderBets, { displayBets: this.state.getDisplayBets, chunkSize: this.state.chunkSize, chunkHeights: this.state.chunkHeights.slice(0, getChunkSizeToRender(this.state.getDisplayBets.length - 1, this.state.chunkSize)), setBetHeight: this.state.setBetHeight });
    }
    renderStatistics() {
        return this.state.config.ShowTotalProfitLossAndBets
            ? React.createElement(ui.ProfitStats, Object.assign({}, this.state.statisticsProps))
            : "";
    }
    renderContent() {
        const placeholdersCount = 3;
        const placeholders = [];
        for (let i = 0; i < placeholdersCount; i++) {
            placeholders.push(React.createElement(ui.PlaceholderBet, { key: `rj-betting-history__placeholder-bet-${i}` }));
        }
        return (this.state.isLoading
            ? React.createElement(React.Fragment, null, placeholders)
            : React.createElement(React.Fragment, null,
                this.renderStatistics(),
                this.renderBets(),
                this.renderLoadMore()));
    }
    render() {
        return (React.createElement("section", { className: "rj-betting-history" },
            this.state.deviceDetect.isDesktop
                ? React.createElement(SelectFilter, { id: "rj-betting-history-filter", data: getDropDownOptions(this.props.dataProvider.dict, this.props.dataProvider.config), key: "rj-betting-history-filter", placeholder: "", onChangeCallback: this.state.updateDateRange, showPlaceHolder: false })
                : React.createElement(DropDown, { id: "rj-betting-history-filter", data: getDropDownOptions(this.props.dataProvider.dict, this.props.dataProvider.config), key: "rj-betting-history-filter", placeholder: "", onChangeCallback: this.state.updateDateRange, showPlaceHolder: false }),
            this.state.isError
                ? this.renderError()
                : this.renderContent()));
    }
};
BettingHistory = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], BettingHistory);
export { BettingHistory };
//# sourceMappingURL=BettingHistory.js.map